/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PostProductResponse } from '../models/post-product-response';
import { updateProducts } from '../fn/product/update-products';
import { UpdateProducts$Params } from '../fn/product/update-products';


/**
 * Product data ingestion. Submits product details to create product mapping requests that must be reviewed and accepted before a product can be used in price or stock synchronization.
 */
@Injectable({ providedIn: 'root' })
export class ProductService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateProducts()` */
  static readonly UpdateProductsPath = '/products';

  /**
   * Submit product data to create product mapping requests (HardBit / XML format).
   *
   * Accepts a bulk XML product payload and creates product mapping requests for admin review.
   *
   * **Authentication**
   *
   * Requires a Bearer JWT token in the `Authorization` header. 
   * The token identifies the merchant submitting product data.
   *
   * **Required authority (one of):**
   * - `EASYLOT_ADMIN`
   * - `PRODUCT_SYNC`
   * - `PRICE_SYNC_ADMIN`
   *
   * **Business behavior**
   *
   * This endpoint does **not** directly create product mappings or synchronize products. 
   * It creates product mapping *requests* that must be reviewed and accepted by an admin 
   * before the product can be used in price or stock synchronization.
   *
   * Until a product mapping request is accepted, price (`POST /prices`) and stock 
   * (`POST /stocks`) sync for that SKU will fail with a missing mapping error.
   *
   * **HTTP 200 does not mean full success**
   *
   * The HTTP status reflects request acceptance, not individual product processing outcome. 
   * Always check the `Status` field of each `Product` element in the response XML.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProducts()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  updateProducts$Response(params: UpdateProducts$Params, context?: HttpContext): Observable<StrictHttpResponse<PostProductResponse>> {
    const obs = updateProducts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Submit product data to create product mapping requests (HardBit / XML format).
   *
   * Accepts a bulk XML product payload and creates product mapping requests for admin review.
   *
   * **Authentication**
   *
   * Requires a Bearer JWT token in the `Authorization` header. 
   * The token identifies the merchant submitting product data.
   *
   * **Required authority (one of):**
   * - `EASYLOT_ADMIN`
   * - `PRODUCT_SYNC`
   * - `PRICE_SYNC_ADMIN`
   *
   * **Business behavior**
   *
   * This endpoint does **not** directly create product mappings or synchronize products. 
   * It creates product mapping *requests* that must be reviewed and accepted by an admin 
   * before the product can be used in price or stock synchronization.
   *
   * Until a product mapping request is accepted, price (`POST /prices`) and stock 
   * (`POST /stocks`) sync for that SKU will fail with a missing mapping error.
   *
   * **HTTP 200 does not mean full success**
   *
   * The HTTP status reflects request acceptance, not individual product processing outcome. 
   * Always check the `Status` field of each `Product` element in the response XML.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProducts$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  updateProducts(params: UpdateProducts$Params, context?: HttpContext): Observable<PostProductResponse> {
    const resp = this.updateProducts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PostProductResponse>): PostProductResponse => r.body)
    );
  }

}
